import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

export default function ImageSlide({ images }: any) {
  // 화살표 버튼을 위한 Ref 생성
  const swiperRef = useRef<any>(null);
  const prevRef = useRef<HTMLButtonElement | null>(null);
  const nextRef = useRef<HTMLButtonElement | null>(null);

  // Swiper 초기화 후 네비게이션 설정을 위한 상태
  const [swiperInstance, setSwiperInstance] = useState<any>(null);

  // index 기준으로 정렬
  const sortedImages = Array.isArray(images)
    ? [...images].sort((a, b) => a.index - b.index)
    : [];

  useEffect(() => {
    if (
      swiperRef.current &&
      swiperRef.current.swiper &&
      prevRef.current &&
      nextRef.current
    ) {
      const swiperInstance = swiperRef.current.swiper;
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);
  return (
    <div
      className="image-slide-wrapper"
      style={{ position: "relative", width: "100%" }}
    >
      {/* 커스텀 네비게이션 버튼 */}
      <button ref={prevRef} className="custom-prev">
        <ChevronLeft />
      </button>
      <button ref={nextRef} className="custom-next">
        <ChevronRight />
      </button>
      <Swiper
        ref={swiperRef}
        modules={[Navigation]}
        spaceBetween={10}
        slidesPerView={1}
        onSwiper={setSwiperInstance} // Swiper 인스턴스를 상태에 저장
        className="work-detail-carousel"
      >
        {sortedImages.map((image: any, index: number) => (
          <SwiperSlide key={index}>
            <img
              className="work-detail-img"
              src={image.url}
              alt={`tmp_img.png`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
